import type { SCFormFieldProps } from './form_field';
import { FormCheckbox } from 'eone-ui/forms/form-checkbox';
import { handleFieldUp } from './helper';
import { SCFormField } from './form_field';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

interface SCFormFieldCheckboxProps extends SCFormFieldProps {
  AutoFocus?: boolean;
  Icon?: IconProp;
  Label?: string;
  onChange?: (newValue: boolean) => void;
}

const SCFormFieldCheckbox = ({
  label,
  name,
  required,
  disabled,
  rules,
  defaultValue,
  onChange,
  ...rest
}: SCFormFieldCheckboxProps) => {
  return (
    <SCFormField
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      rules={rules}
      defaultValue={defaultValue ?? false}
    >
      {({ field }) => {
        const { OnChange: OnFieldChange, ...restField } = handleFieldUp(field, {
          disabledRef: true,
        });

        return (
          <>
            {/* Crying, it should be onToggle instead of onChange */}
            <FormCheckbox
              {...restField}
              OnToggle={(newValue) => {
                onChange?.(newValue);
                OnFieldChange(newValue);
              }}
              ReadOnly={restField.Disabled}
              Label={label}
              {...rest}
            />
          </>
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldCheckbox };
export type { SCFormFieldCheckboxProps };
